import { useFetchWithoutToken } from "../query/reactQuery";
import STATIC_API_URLS, { StaticApiUrls } from "./urls/staticUrls";

export const useGetStaticParams = (param: string, enabled: boolean) =>
    useFetchWithoutToken<any>(STATIC_API_URLS[param as keyof StaticApiUrls], {}, { enabled: enabled }, process.env.REACT_APP_API_PARAMS_URL);
